var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdexStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_x0020_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.267,
    height: 67.784,
    viewBox: "0 0 161.267 67.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2406353437392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M0,44.654,12.424,32.231,0,19.808,8.21,11.6l.7-.7.077-.077L19.807,0l2.674,2.674L5.348,19.808,17.771,32.231,7.777,42.225,5.347,44.654,22.481,61.787l-2.674,2.674L9.52,54.174Z",
    fill: "#7398fe",
    fillRule: "evenodd",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M689.44,44.654l12.424-12.424L689.441,19.808l8.833-8.836h0L709.247,0,713.3,4.052l-6.77,6.77-.077.077-.7.7-8.209,8.212,12.423,12.422L697.544,44.654l9.52,9.519,6.235,6.235-4.052,4.052L697.956,53.17Z",
    transform: "translate(-680.533)",
    fill: "#7398fe",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1761",
    "data-name": "Group 1761",
    transform: "translate(20.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M1592.18,994.591l12.424-12.423-12.423-12.423,7.375-7.375,12.433,12.433,12.434-12.433,7.374,7.375-12.423,12.423,12.423,12.423-7.385,7.384-12.423-12.424-12.423,12.424Z",
    transform: "translate(-1592.18 -949.937)",
    fill: "#7398fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M2227.66,11.6l11.6-11.6,11.6,11.6-6.222,6.222-5.375-5.375-5.375,5.375Z",
    transform: "translate(-2219.45)",
    fill: "#2c5cde",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M2227.66,3616.451l11.6,11.6,11.6-11.6-6.222-6.221-5.375,5.375-5.375-5.375Z",
    transform: "translate(-2219.45 -3563.588)",
    fill: "#2c5cde",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(64.797 18.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M5015.439,1578.657h6.471l2.348-6.117h9.868l2.315,6.117h6.724l-10.231-25.337h-7.122Zm10.7-11.076,3.108-8.108,3.038,8.108Z",
    transform: "translate(-5015.439 -1552.053)",
    fill: "#a7befb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M7200.385,1481.845h5.783v-26.6l-5.855,1.268v7.2a9.864,9.864,0,1,0-5.061,18.39,8.618,8.618,0,0,0,5.133-1.666Zm-9.145-9.593a4.845,4.845,0,0,1,5.024-4.85,5.915,5.915,0,0,1,4.048,1.485v6.7a5.618,5.618,0,0,1-4.048,1.521A4.867,4.867,0,0,1,7191.24,1472.252Z",
    transform: "translate(-7157.454 -1455.24)",
    fill: "#a7befb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M9142.9,1578.657H9163v-5.393h-13.878v-4.777h9.072v-5.213h-9.072v-4.56h13.736v-5.393H9142.9Z",
    transform: "translate(-9089.575 -1552.053)",
    fill: "#a7befb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M10831.7,2051.6h6.542l3.979-5.466,4.01,5.466h6.8l-7.444-9.773,7.047-9.374h-6.543l-3.721,5.139-3.762-5.139h-6.8l7.158,9.448Z",
    transform: "translate(-10756.557 -2024.993)",
    fill: "#a7befb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M5020.435,3921.685c3.5,0,5.194-1.749,5.194-3.793,0-4.495-7.119-2.935-7.119-5.195,0-.772.647-1.4,2.327-1.4a6.913,6.913,0,0,1,3.393.962l.875-2.151a8.212,8.212,0,0,0-4.25-1.084c-3.481,0-5.16,1.731-5.16,3.816,0,4.547,7.118,2.973,7.118,5.265,0,.749-.682,1.309-2.361,1.309a7.224,7.224,0,0,1-4.04-1.274l-.961,2.131a8.726,8.726,0,0,0,4.985,1.417Zm12.278-2.589a1.838,1.838,0,0,1-1.1.35,1.1,1.1,0,0,1-1.172-1.242v-3.831h2.344v-2.1h-2.344v-2.291h-2.729v2.291h-1.451v2.1h1.451v3.865c0,2.239,1.295,3.376,3.516,3.376a3.9,3.9,0,0,0,2.222-.595l-.734-1.924Zm6.069-7.171a7.234,7.234,0,0,0-4.058,1.137l.979,1.906a4.526,4.526,0,0,1,2.711-.875c1.469,0,2.169.682,2.169,1.854h-2.169c-2.868,0-4.04,1.154-4.04,2.816,0,1.626,1.312,2.851,3.516,2.851a3.087,3.087,0,0,0,2.868-1.312v1.172h2.554v-5.37C5043.312,3913.254,5041.65,3911.925,5038.782,3911.925Zm-.21,7.853c-.962,0-1.539-.455-1.539-1.137,0-.63.4-1.1,1.679-1.1h1.871v.962A2.01,2.01,0,0,1,5038.572,3919.778Zm14.219,1.7h3.306l-4.268-5.422,3.918-3.988h-3.253l-3.988,3.778V3908.5h-2.729v12.978h2.729v-2.4l1.312-1.294,2.973,3.691Zm5.825-10.722a1.569,1.569,0,0,0,1.7-1.574,1.532,1.532,0,0,0-1.7-1.469,1.531,1.531,0,1,0,0,3.043Zm-1.364,10.722h2.729v-9.41h-2.729Zm10.984-9.55a4.119,4.119,0,0,0-3.113,1.242v-1.1h-2.606v9.41h2.729v-4.653c0-1.731.944-2.536,2.256-2.536,1.207,0,1.906.7,1.906,2.221v4.967h2.729v-5.387C5072.136,3913.22,5070.457,3911.925,5068.235,3911.925Zm13.59.14v1.207a3.776,3.776,0,0,0-3.113-1.347,4.55,4.55,0,1,0,0,9.095,3.874,3.874,0,0,0,2.974-1.172v.4c0,1.7-.84,2.571-2.764,2.571a5.626,5.626,0,0,1-3.323-1.067l-1.084,1.959a7.751,7.751,0,0,0,4.617,1.294c3.394,0,5.282-1.609,5.282-5.107v-7.836Zm-2.571,6.716a2.314,2.314,0,1,1,2.466-2.309A2.3,2.3,0,0,1,5079.254,3918.781Z",
    transform: "translate(-4950.652 -3857.224)",
    fill: "#7298fe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdexStaking);
export default __webpack_public_path__ + "static/media/adex_staking.f53ff0f440f1796290440e0a8bf5c2c0.svg";
export { ForwardRef as ReactComponent };